import { MessageType } from "../agentService";
import { Api, ApiConfig } from '../api';
import { StreamApi } from "../streamApi";

export interface DashboardRequest {
    task: string;
    metadata: any;
    conversation_id?: string;
    history?: MessageType[];
}

export class NextService {
    private api: Api;
    private streamApi: StreamApi;

    constructor(config: ApiConfig) {
        this.api = new Api(config);
        this.streamApi = new StreamApi(config);
    }

    dashboardStream(
        data: DashboardRequest,
        onMessage: (data: any) => void | Promise<void>,
        onError?: (error: any) => void,
        signal?: AbortSignal
    ) {
        return this.streamApi.post({ 
            url: '/api/agent/dashboard', 
            body: data,
            onMessage: (data: any) => {
                onMessage(data);
            },
            onError,
            signal
        });
    }
}

export const nextService = new NextService({
    // baseURL: 'http://localhost:3000',
    baseURL: '',
    headers: {'Content-Type': 'application/json',},
    debugMode: false
});